import React from 'react'
import Popup from '../Popup/index';
// import { connect } from 'react-redux'

import Registry from '../../../registry/index';
import Snapshot from './Snapshot';
import ShortUserInfo from './ShortUserInfo';
import ShortAdminInfo from './ShortAdminInfo';


class UserInfoTooltip extends Popup {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: {
                pro: false,
                ...props.currentUser
            }
        };

        this.allowReopenPopup = false;
    }

    render() {
        let lang = Registry.get('locale');

        let {currentUser} = this.state;
        let {user, watchingMe} = this.props;

        let className = 'popup user-info ' + this.state.visibility;
        return (
            <div className={className} ref={(popup) => this._ref = popup}>
                {user.stub ?
                    <InfoStub user={user} lang={lang}/> :
                    <InfoFull user={user} watchingMe={watchingMe} lang={lang} currentUser={currentUser}/>
                }
                <ShortAdminInfo data={user.admin_data} />
                <ShortAdminInfo data={user.hitagi_admin_data} />
            </div>
        )
    }
}

function InfoFull(props) {
    let {user, lang, currentUser} = props;
    
    let certifiedDisplayed = !user.isCertified() ? <li className="certified">{lang.info_cannot_write}</li> : null;

    return (
        <ul>
            <li>
                <Snapshot 
                    user={user} 
                    currentUser={currentUser}
                />
            </li>
            <li className="nick"><span className="name">{user.nick}</span> {user.isXXL() ? <span className="XXL">XXL</span> : null}</li>
            <li className="string">
                <ShortUserInfo 
                    user={user}
                    lang={lang}
                />
            </li>
            {certifiedDisplayed}

            {user.mood ? <li className="status">{lang.mood}:</li> : null}
            {user.mood ? <li className="string">{user.mood}</li> : null}
        </ul>
    )
}

function InfoStub(props) {
    let {user, lang} = props;

    return (
        <ul>
            <li className="nick">{user.nick}</li>
            <li>{lang.offline}</li>
        </ul>
    )
}

UserInfoTooltip.generateKey = function() { return 'user-list-item-tooltip' };
UserInfoTooltip.mount = function(props) { return Popup.mount(UserInfoTooltip, props) };

export default UserInfoTooltip;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserInfoTooltip/index.js